import type { FC } from 'react';

const BADGE_BG_COLOR = '#FF6E00';

const BADGE__CLS =
  'absolute top-2 left-2 max-w-[calc(100%-16px)] truncate rounded-lg px-2 py-1 text-xs font-medium leading-[14px] text-white';

interface BarMenuCategoryBadgeProps {
  text: string;
}

const BarMenuCategoryBadge: FC<BarMenuCategoryBadgeProps> = ({ text }) => (
  <span className={BADGE__CLS} style={{ backgroundColor: BADGE_BG_COLOR }}>
    {text}
  </span>
);

export default BarMenuCategoryBadge;
